import moment from 'moment';
import { ConfigConstants } from '../../config/config-constants';
import { ClientManagerInstanceToken } from '../../interfaces/client-manager.interface';
import { CompositeModel } from '../../models/complex/composite.model';
import { TimeZoneModel } from '../../models/complex/time-zone.model';
import { NotificationIdentifierModel } from '../../models/low-level/notification-identifier.model';
import { NotificationModel } from '../../models/low-level/notification.model';
import { TextModel } from '../../models/primitive/text.model';
import { CustomInjector } from '../../services/custom-injector/custom-injector';
import { UserMasterService } from '../../services/user-master/user-master.service';

import { NOTIFICATION_STATUS_CODE } from '../../enums/notification-status-code.enum';
import { NotificationService } from '../../services/notification/notification.service';
import { NotificationUtilities } from '../../utilities/notification-utilities';

export class CancellationModel extends CompositeModel {
    public contactName: string;
    public notificationType: string; // This string used on UI
    public notification: NotificationModel;
    private notificationIdentifier: NotificationIdentifierModel;
    private timeZone: TimeZoneModel;
    private notificationStatus: TextModel;
    private confirmDate: TextModel;
    private confirmTime: TextModel;
    public constructor(
        public notificationModel: NotificationModel,
        public notificationUpdateKey: string,
    ) {
        super('CancellationModel');

        // Dependency loading
        const injector = CustomInjector.getInjector();
        const notificationUtilities = injector.get(NotificationUtilities);
        const notificationService = injector.get(NotificationService);
        const userMasterService = injector.get(UserMasterService);
        const clientManager = injector.get(ClientManagerInstanceToken);

        // Setup model
        this.contactName = notificationModel.address.completeName;
        this.notificationType = notificationUtilities.getNotificationTypeDescription(notificationModel);
        this.notification = notificationModel;
        this.notificationIdentifier = <NotificationIdentifierModel>this.set(notificationModel.identifier);
        this.timeZone = <TimeZoneModel>this.set(notificationModel.timeZone);
        // get the cancelled status string, updated using the whats new message type, can be AVR1 or AVR2
        const cancelledStatus = <NOTIFICATION_STATUS_CODE>notificationService.getCancelled(this.notification);
        // if the notification is in progress then status back to AVRF
        // if not in progress check if cancelled status exists
        // if exists set the status to that value else just default it to AVR1 (if every case fails)
        let status: NOTIFICATION_STATUS_CODE;
        if (notificationService.isNotificationInProgressAndCancelled(this.notification)) {
            status = NOTIFICATION_STATUS_CODE.AVRF;
        } else {
            status = cancelledStatus ? cancelledStatus : NOTIFICATION_STATUS_CODE.AVR1;
        }
        this.notificationStatus = <TextModel>this.set(new TextModel('Status', status));
        this.confirmDate = <TextModel>(
            this.set(new TextModel('Date', moment().format(ConfigConstants.formatDateNoTimezone)))
        );
        this.confirmTime = <TextModel>(
            this.set(new TextModel('Time', moment().format(ConfigConstants.formatXSDTimeDuration)))
        );

        if (clientManager.isNgmAP0()) {
            userMasterService.setSalesOrgAndPlantForModel(this);
        }
    }
}
